import { gql } from "@apollo/client";

const GET_CERTS = gql`
  query {
    participationCerts {
      classesCount
      downloadLink
      level {
        id
        title
      }
    }
    graduationCerts {
      progressPercentage
      downloadLink
      level {
        id
        title
      }
    }
  }
`;

export default GET_CERTS;
